import { useMutation } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { updatePatient } from 'api/auth.api';

export const useUpdatePatient = ({ onSuccess } = {}) => {
  const toast = useToast();

  return useMutation({
    mutationFn: updatePatient,
    onSuccess: (res) => {
      toast({
        title: 'Patient Details updated',
        description: res?.data?.message || 'Updated successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top-center',
      });

      onSuccess?.(res);
    },

    onError: (error) => {
      toast({
        title: 'Failed to update patient details',
        description: error?.response?.data?.message || 'Something went wrong',
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top-center',
      });
    },
  });
};
